import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { motion } from "framer-motion";
import { useAuth } from "@/context/AuthContext";
import Header from "@/components/Header";
import { ArrowLeft, Loader2, Lock, Trophy } from "lucide-react";

export default function Conquistas() {
  const { http } = useAuth();
  const navigate = useNavigate();
  const [summary, setSummary] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    http.get("/me/summary").then(({ data }) => setSummary(data)).catch(() => {}).finally(() => setLoading(false));
  }, [http]);

  const achievements = summary?.achievements || [];
  const unlocked = achievements.filter((a) => a.unlocked).length;

  return (
    <div className="min-h-screen">
      <Header />
      <div className="max-w-3xl mx-auto px-5 py-8">
        <button onClick={() => navigate("/")} className="inline-flex items-center gap-2 text-sm text-slate-400 hover:text-white mb-6 transition-colors">
          <ArrowLeft className="w-4 h-4" /> Voltar
        </button>

        <div className="flex items-center gap-3">
          <div className="w-11 h-11 rounded-2xl grid place-items-center bg-[#F59E0B]/15 text-[#F59E0B]"><Trophy className="w-5 h-5" /></div>
          <div>
            <h1 className="font-display font-black text-3xl tracking-tighter leading-none">Conquistas</h1>
            <p className="text-sm text-slate-400 mt-1">{unlocked} de {achievements.length} desbloqueadas</p>
          </div>
        </div>

        {loading ? (
          <div className="flex justify-center py-20"><Loader2 className="w-8 h-8 animate-spin text-[#F43F5E]" /></div>
        ) : (
          <div className="grid grid-cols-2 sm:grid-cols-3 gap-3 mt-8">
            {achievements.map((a, i) => (
              <motion.div key={a.id} data-testid={`ach-${a.id}`}
                initial={{ opacity: 0, scale: 0.9 }} animate={{ opacity: 1, scale: 1 }} transition={{ delay: i * 0.04 }}
                className={`relative flex flex-col items-center text-center gap-2 p-5 rounded-3xl border ${a.unlocked ? "bg-white/5 border-[#F59E0B]/40" : "bg-white/[0.03] border-white/10"}`}
                style={a.unlocked ? { boxShadow: "0 8px 30px -18px #F59E0B" } : {}}>
                <span className={`text-4xl ${a.unlocked ? "" : "grayscale opacity-40"}`}>{a.emoji}</span>
                <p className={`text-sm font-semibold ${a.unlocked ? "" : "text-slate-500"}`}>{a.nome}</p>
                <p className="text-[11px] text-slate-400 leading-tight">{a.desc}</p>
                {!a.unlocked && <Lock className="w-3.5 h-3.5 text-slate-600 absolute top-3 right-3" />}
              </motion.div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
}
